export function calculateClassCompletionPercentage(crecerSteps) {
  if (!crecerSteps.length) return 0; // Return 0 if the array is empty
  const record = crecerSteps[0]; // Get the first item in the array
  const classKeys = Object.keys(record).filter((key) => key.startsWith('class'));

  const completedClasses = classKeys.filter(
    (key) => typeof record[key] === 'string' && !isNaN(Date.parse(record[key]))
  ).length;

  return classKeys.length > 0 ? (completedClasses / classKeys.length) * 100 : 0;
}

export function countCompletedClasses(crecerSteps) {
  if (!crecerSteps.length) return 0; // Return 0 if the array is empty
  const record = crecerSteps[0]; // Get the first item in the array
  const classKeys = Object.keys(record).filter((key) => key.startsWith('class'));
  return classKeys.filter(
    (key) => typeof record[key] === 'string' && !isNaN(Date.parse(record[key]))
  ).length;
}

export const handleCrecerCompletion = ({
  courseCode,
  guest,
  setSelectedCourse,
  setNotificationError,
}) => {
  switch (courseCode) {
    case 'crecerVida':
      const percentPD = calculateClassCompletionPercentage(guest.CrecerVidaSteps);
      if (percentPD >= 80 || guest.CrecerVidaSteps[0]?.percentage >= 80) {
        setSelectedCourse?.(courseCode);
        return true;
      }
      setNotificationError?.(
        `Lo sentimos; no cuentas aún con el 80% de asistencia a las clases de este curso, por favor verifica las clases que te hacen falta y las fechas en que se impartirán. Porcentaje actual: ${Math.trunc(
          percentPD
        )}%`
      );
      return false;
    case 'crecerInfluence':
      const percentPT = calculateClassCompletionPercentage(guest.CrecerInfluenceSteps);

      if (percentPT >= 80 || guest.CrecerInfluenceSteps[0]?.percentage >= 80) {
        setSelectedCourse?.(courseCode);
        return true;
      }
      setNotificationError?.(
        `Lo sentimos; no cuentas aún con el 80% de asistencia a las clases de este curso, por favor verifica las clases que te hacen falta y las fechas en que se impartirán. Porcentaje actual: ${Math.trunc(
          percentPT
        )}%`
      );
      return false;
    case 'Ruta128':
      const completedClassesRuta128 = countCompletedClasses(
        guest.Seminaries.filter((s) => s.seminary === courseCode)
      );
      if (completedClassesRuta128 >= 1) {
        setSelectedCourse?.(courseCode);
        return true;
      }
      setNotificationError?.(
        `Lo sentimos; no cuentas aún con el número de asistencia suficientes a las clases de este curso, por favor verifica las clases que te hacen falta y las fechas en que se impartirán. Clases actuales: ${completedClassesRuta128}`
      );
      return false;
    default:
      const completedClassesSeminary = countCompletedClasses(
        guest.Seminaries.filter((s) => s.seminary === courseCode)
      );
      if (completedClassesSeminary >= 9) {
        setSelectedCourse?.(courseCode);
        return true;
      }
      setNotificationError?.(
        `Lo sentimos; no cuentas aún con el número de asistencia suficientes a las clases de este curso, por favor verifica las clases que te hacen falta y las fechas en que se impartirán. Clases actuales: ${completedClassesSeminary}`
      );
      return false;
  }
};
